import { createSlice } from '@reduxjs/toolkit';
import { EarningState } from './earningTypes';
import { createEarning, fetchEarnings, fetchEarningById, updateEarning, deleteEarning } from './earningActions';

const initialState: EarningState = {
  earnings: [],
  selectedEarning: undefined,
  loading: false,
  error: undefined,
};

const earningSlice = createSlice({
  name: 'earning',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Earning
      .addCase(createEarning.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createEarning.fulfilled, (state, action) => {
        state.loading = false;
        state.earnings.push(action.payload);
      })
      .addCase(createEarning.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Earnings
      .addCase(fetchEarnings.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEarnings.fulfilled, (state, action) => {
        state.loading = false;
        state.earnings = action.payload.data;
      })
      .addCase(fetchEarnings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Earning by ID
      .addCase(fetchEarningById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEarningById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedEarning = action.payload.data;
      })
      .addCase(fetchEarningById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Earning
      .addCase(updateEarning.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateEarning.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.earnings.findIndex(earning => earning.id === action.payload.id);
        if (index !== -1) {
          state.earnings[index] = action.payload;
        }
      })
      .addCase(updateEarning.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Earning
      .addCase(deleteEarning.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteEarning.fulfilled, (state, action) => {
        state.loading = false;
        state.earnings = state.earnings.filter(earning => earning.id !== action.payload.id);
      })
      .addCase(deleteEarning.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default earningSlice.reducer;
